import Immutable from 'immutable';
import { useCallback } from 'react';
import { useLocalStorage } from 'core/hooks/useLocalStorage';

export const useDemoChunkVisits = (lessonId) => {
  const [chunkVisits, setChunkVisits] = useLocalStorage(
    `lesson-demo-chunkviews-${lessonId}`,
    Immutable.List(),
    !!'isImmutable'
  );

  return {
    data: chunkVisits,
    isLoading: false,
    error: null,
    recordChunkVisit: useCallback(
      (_, chunkId) => {
        setChunkVisits((oldChunkVisits) => {
          const chunkVisitIndex = oldChunkVisits.findIndex(
            (chunkVisit) => chunkVisit.get('chunk') === chunkId
          );
          return chunkVisitIndex < 0
            ? oldChunkVisits.push(
                Immutable.Map({ chunk: chunkId, visitCount: 1 })
              )
            : oldChunkVisits.updateIn(
                [chunkVisitIndex, 'visitCount'],
                (count) => count + 1
              );
        });
      },
      [setChunkVisits]
    ),
  };
};
